import HttpClient from "./index"
import ApiRoutes, { baseUrl } from "../config/endpoints"

export default class DashboardAPI extends HttpClient {
  constructor() {
    super(baseUrl)
    this._initializeRequestInterceptor()
  }

  // customer mangement
  adminDashboard = ApiRoutes.Dashboard.AdminDashboard
  csmDashboard = ApiRoutes.Dashboard.CsmDashboard
  advisorDashboard = ApiRoutes.Dashboard.AdvisorDashboard
  gaDashboard = ApiRoutes.Dashboard.GaDashboard
  OverviewTab = ApiRoutes.Dashboard.Overview
  opportunityTab = ApiRoutes.Dashboard.Opportunity
  doctorsTab = ApiRoutes.Dashboard.Doctors
  hygienistsTab = ApiRoutes.Dashboard.Hygienists
  dashboardCharts = ApiRoutes.Dashboard.DashboardCharts
  topMetrics = ApiRoutes.Dashboard.TopMetrics
  topMetricCharts = ApiRoutes.Dashboard.TopMetricCharts

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this._handleRequest)
  }

  _handleRequest = async (axiosConfig: any) => {
    return axiosConfig
  }

  getAdminDashboardData = (token: string) => {
    return this.instance({
      method: this.adminDashboard.Method,
      url: this.adminDashboard.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
  getCsmDashboardData = (token: string, csmId: any) => {
    return this.instance({
      method: this.csmDashboard.Method,
      url: this.csmDashboard.EndPoint(csmId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
  getAdvisorDashboardData = (token: string, advisorId: any) => {
    return this.instance({
      method: this.advisorDashboard.Method,
      url: this.advisorDashboard.EndPoint(advisorId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
  getGaDashboardData = (token: string, gaId: any) => {
    return this.instance({
      method: this.gaDashboard.Method,
      url: this.gaDashboard.EndPoint(gaId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
  getOverviewTab = (
    token: any,
    group_sk: string,
    region: string,
    practice_sk: string,
  ) => {
    return this.instance({
      method: this.OverviewTab.Method,
      url: this.OverviewTab.EndPoint(group_sk, region, practice_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  getOpportunityTab = (
    token: any,
    group_sk: string,
    region: string,
    practice_sk: string,
  ) => {
    return this.instance({
      method: this.opportunityTab.Method,
      url: this.opportunityTab.EndPoint(group_sk, region, practice_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }

  getDoctorsTab = (
    token: any,
    group_sk: string,
    region: string,
    practice_sk: string,
    start_date: string,
    end_date: string,
  ) => {
    return this.instance({
      method: this.doctorsTab.Method,
      url: this.doctorsTab.EndPoint(
        group_sk,
        region,
        practice_sk,
        start_date,
        end_date,
      ),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  getHygienistsTab = (
    token: any,
    group_sk: string,
    region: string,
    practice_sk: string,
    start_date: string,
    end_date: string,
  ) => {
    return this.instance({
      method: this.hygienistsTab.Method,
      url: this.hygienistsTab.EndPoint(
        group_sk,
        region,
        practice_sk,
        start_date,
        end_date,
      ),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }

  getDashboardCharts = (
    token: any,
    group_sk: string,
    region: string,
    practice_sk: string,
  ) => {
    return this.instance({
      method: this.dashboardCharts.Method,
      url: this.dashboardCharts.EndPoint(group_sk, region, practice_sk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }

  getTopMetrics = (token: any) => {
    return this.instance({
      method: this.topMetrics.Method,
      url: this.topMetrics.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }

  postTopMetricsCharts = (
    token: any,
    group_sk: string,
    region: string,
    practice_sk: string,
    metric_list: any[],
  ) => {
    return this.instance({
      method: this.topMetricCharts.Method,
      url: this.topMetricCharts.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        group_sk,
        region,
        practice_sk,
        metric_list,
      },
    })
  }
}
